// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__201Sb","selects":"Documents_selects__15Bim"};